import { serverSideConfigs, t } from 'localization'
import Head from 'next/head'
import ForgotPassword from 'password/ForgotPassword'
import PanelPageLayout from 'shared/components/Panel/PanelPageLayout'
import { FCGetServerSidePropsContext, getServerPageProps } from 'shared/utils/getServerSideProps'

const TP = 'pages.customer.account.forgotpassword'

export default () => (
  <>
    <Head>
      <title>{t(`${TP}.pageTitle`, 'Forgot Your Password | Flight Club')}</title>
    </Head>
    <PanelPageLayout>
      <ForgotPassword />
    </PanelPageLayout>
  </>
)

export const getServerSideProps = async (context: FCGetServerSidePropsContext) => {
  const { res, locale } = context
  return {
    props: {
      ...(await getServerPageProps(context)),
      ...(await serverSideConfigs(res, locale)),
    },
  }
}
